import { withCarouselContainer } from '@recommendations-fe/commons';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import 'prop-types';
import { jsx } from 'react/jsx-runtime';
const _excluded = ["carouselType", "carousels"];
const CarouselByType = _ref => {
  let {
      carouselType = null,
      carousels
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  let Carousel = null;
  if (carouselType) {
    Carousel = carousels[carouselType.toLowerCase()];
  }
  if (!carouselType || !Carousel) {
    Carousel = carousels.default;
  }
  return /*#__PURE__*/jsx(Carousel, _objectSpread({}, props));
};
var CarouselByType$1 = CarouselByType;
var index = withCarouselContainer(CarouselByType$1);
export { index as default };
